import { createIcon } from '@chakra-ui/icons';

export const TrackScorm = createIcon({
  displayName: 'TrackScorm',
  viewBox: '0 0 20 20',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <rect width="20" height="20" rx="10" fill="#FDE9C8" />
      <g clipPath="url(#clip0_308_4097)">
        <path
          d="M12.917 11.668C13.8337 11.668 14.5837 10.918 14.5837 10.0013C14.5837 9.08464 13.8337 8.33464 12.917 8.33464C12.792 6.70964 11.4587 5.41797 9.79199 5.41797C8.12533 5.41797 6.75033 6.7513 6.66699 8.3763C5.95866 8.54297 5.41699 9.20964 5.41699 10.0013C5.41699 10.918 6.16699 11.668 7.08366 11.668"
          stroke="#977334"
          strokeWidth="0.833333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M10.417 10.002L9.16699 12.0853H10.8337L9.58366 14.1686"
          stroke="#977334"
          strokeWidth="0.833333"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_308_4097">
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
